export default "__VITE_ASSET__d8a0de70__"